import { IColumnType, IFilterItem } from '@/components/ZTable';
import { t } from 'i18next';
import { InfoOutlined } from '@ant-design/icons';
import { Button, Modal, Tooltip } from 'antd';
import React from 'react';
import { formatDisplayFullDate } from '@/config';
import { SmsProviderType } from '@/constants';
import BooleanTag from '@/components/app/BooleanTag';
import { EmailMessage, SmsMessage } from '@/__generated';

export const emailColumns: IColumnType<EmailMessage>[] = [
  {
    title: t('notificationsPage_EmailSubject'),
    dataIndex: 'subject',
    ellipsis: true,
    width: 300,
  },
  {
    title: t('notificationsPage_ToEmail'),
    dataIndex: 'toEmails',
    ellipsis: true,
    width: 200,
  },
  {
    title: t('notificationsPage_FromEmail'),
    dataIndex: 'fromName',
    render: (v, email) => `${v} - ${email.fromAddress}`,
    width: 200,
    ellipsis: true,
  },

  {
    width: 120,
    align: 'center',
    title: t('notificationsPage_EmailContent'),
    dataIndex: 'bodyContent',
    render(bodyContent: any) {
      return (
        <Button
          size="small"
          shape="circle"
          icon={<InfoOutlined />}
          onClick={() => {
            Modal.info({
              title: t('notificationsPage_EmailContent') as any,
              content: <div dangerouslySetInnerHTML={{ __html: bodyContent }} />,
              width: 700,
            });
          }}
        ></Button>
      );
    },
  },
  {
    title: t('base.CreatedOn'),
    dataIndex: 'createdOn',
    render: (value: any) => {
      return formatDisplayFullDate(value);
    },
    width: 150,
    ellipsis: true,
  },
  {
    title: t('notificationsPage_SentOn'),
    dataIndex: 'sentOn',
    render: (value: any) => {
      return formatDisplayFullDate(value);
    },
    width: 150,
    ellipsis: true,
  },
  {
    title: t('notificationsPage_Error'),
    dataIndex: 'error',
    align: 'center',
    width: 100,
    render: v => {
      return v ? (
        <Button
          danger
          size="small"
          shape="circle"
          icon={<InfoOutlined />}
          onClick={() => {
            Modal.error({
              title: t('notificationsPage_Error') as any,
              content: <div dangerouslySetInnerHTML={{ __html: v }} />,
              width: 700,
            });
          }}
        ></Button>
      ) : (
        <></>
      );
    },
  },
];

export const emailFilters: Array<IFilterItem> = [
  { type: 'TEXT', name: 'subject', label: 'notificationsPage_EmailSubject' },
  { type: 'TEXT', name: 'toEmail', label: 'notificationsPage_ToEmail' },
];

export const smsFilters: Array<IFilterItem> = [{ type: 'TEXT', name: 'phoneNumber', label: 'notificationsPage_PhoneNumber' }];

export const smsColumns: IColumnType<SmsMessage>[] = [
  {
    title: t('notificationsPage_PhoneNumber'),
    dataIndex: 'phoneNumber',
    ellipsis: true,
    width: 300,
  },
  {
    title: t('notificationsPage_SmsProvider'),
    dataIndex: 'smsProvider',
    ellipsis: true,
    width: 150,
    render: v => SmsProviderType.__getValue(v),
  },
  {
    title: t('notificationsPage_CountryCode'),
    dataIndex: 'countryCode',
    width: 150,
    ellipsis: true,
  },
  {
    width: 200,
    title: t('notificationsPage_Message'),
    dataIndex: 'message',
    ellipsis: true,
    render: v => <Tooltip title={v}>{v}</Tooltip>,
  },

  {
    title: t('base.CreatedOn'),
    dataIndex: 'createdOn',
    render: (value: any) => {
      return formatDisplayFullDate(value);
    },
    width: 150,
    ellipsis: true,
  },
  {
    title: t('notificationsPage_SentOn'),
    dataIndex: 'sentOn',
    render: (value: any) => {
      return formatDisplayFullDate(value);
    },
    width: 150,
    ellipsis: true,
  },
  {
    title: t('notificationsPage_Error'),
    dataIndex: 'error',
    align: 'center',
    width: 100,
    render: v => {
      return v ? (
        <Button
          danger
          size="small"
          shape="circle"
          icon={<InfoOutlined />}
          onClick={() => {
            Modal.error({
              title: t('notificationsPage_Error') as any,
              content: <div dangerouslySetInnerHTML={{ __html: v }} />,
              width: 700,
            });
          }}
        ></Button>
      ) : (
        <></>
      );
    },
  },
];

export const notificationColumns: IColumnType<Notification>[] = [
  {
    title: t('notificationsPage_SenderName'),
    dataIndex: 'senderName',
    ellipsis: true,
    width: 300,
  },
  {
    title: t('notificationsPage_ToUser'),
    dataIndex: 'toUser',
    ellipsis: true,
    width: 200,
  },

  {
    width: 200,
    title: t('notificationsPage_Message'),
    dataIndex: 'message',
    ellipsis: true,
    render: v => <Tooltip title={v}>{v}</Tooltip>,
  },

  {
    width: 120,
    title: t('notificationsPage_IsEnable'),
    dataIndex: 'isEnable',
    render: v => <BooleanTag value={v} />,
  },
  {
    title: t('base.CreatedOn'),
    dataIndex: 'createdOn',
    render: (value: any) => {
      return formatDisplayFullDate(value);
    },
    width: 150,
    ellipsis: true,
  },
  {
    title: t('notificationsPage_SentOn'),
    dataIndex: 'sentOn',
    render: (value: any) => {
      return formatDisplayFullDate(value);
    },
    width: 150,
    ellipsis: true,
  },
  {
    title: t('notificationsPage_Error'),
    dataIndex: 'error',
    align: 'center',
    width: 100,
    render: v => {
      return v ? (
        <Button
          danger
          size="small"
          shape="circle"
          icon={<InfoOutlined />}
          onClick={() => {
            Modal.error({
              title: t('notificationsPage_Error') as any,
              content: <div dangerouslySetInnerHTML={{ __html: v }} />,
              width: 700,
            });
          }}
        ></Button>
      ) : (
        <></>
      );
    },
  },
];
